import {
    Source
  } from 'one-model-local';

import {
    Action,
} from 'one-state';

import {
    REINIT,
    ADD,
    SPIN,
} from './types';

/**
 * Redux action creator start or stop
 * spin for provider global search modal pop up
 * @param show contains boolean value either false or true
 * @returns action instance
 */
export const setSpin = (show: boolean):
    Action<typeof SPIN, boolean> => ({
        type: SPIN,
        payload: show,
    });    

/**
 * Redux action creator to add the response to state 
 * @param data conatins the data from getproviderinfo api
 */
export const addAction = (data: Source[]):
    Action<typeof ADD, Source[]> => ({
        type: ADD,
        payload: data,
    });

/**
 * Re-initialize the state
 * @returns action instance 
 */
export const reinitAction = ():
    Action<typeof REINIT> => ({
        type: REINIT,
    });


/**
 * List of all valid actions
 */
export type Actions =
    ReturnType<typeof addAction> |
    ReturnType<typeof setSpin> |
    ReturnType<typeof reinitAction>;
